import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
   static values = {
      usedInTurboFrame: { type: Boolean, default: false }
   };

   connect() {
      if (this.usedInTurboFrameValue && !this.element.open) {
         this.show();
      }
   }

   show(event) {
      this.element.showModal();
      this.element.classList.add("grid");
   }

   close(event) {
      this.element.close();
      this.element.classList.remove("grid");
      if (this.usedInTurboFrameValue) {
         this.element.remove();
      }
   }
}
